module.exports = __webpack_public_path__ + "img/tooFacedGloss2.51d358d5.jpg";